import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import Icon from "@/components/icon/Icon.vue";
let QuizReadonlyAlert = class QuizReadonlyAlert extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "isSpeachTemplate", void 0);
  }
  get warningMessage() {
    if (this.isSpeachTemplate) {
      return this.$t('view.speach.quiz.warning.noSave.template');
    } else {
      return this.$t('view.speach.quiz.warning.noSave.editor');
    }
  }
};
__decorate([Prop({
  default: false
})], QuizReadonlyAlert.prototype, "isSpeachTemplate", void 0);
QuizReadonlyAlert = __decorate([Component({
  components: {
    Icon
  }
})], QuizReadonlyAlert);
export default QuizReadonlyAlert;